module.exports = __webpack_public_path__ + "img/peas.1f830c26.svg";